export interface ISpaceProps {
    size: "xxxs" | "xxs" | "xs" | "s" | "m" | "l" | "xl" | "xxl";
}

export const spacingMap = {
    xxxs: "1px",
    xxs: "3px",
    xs: "6px",
    s: "9px",
    m: "24px",
    l: "32px",
    xl: "42px",
    xxl: "60px",
};
